import { RefObject, useEffect } from 'react';

export const useResizeObserver = (ref: RefObject<HTMLDivElement>, callback: () => void) => {
  useEffect(() => {
    const observer = new ResizeObserver(callback);
    if (ref.current) observer.observe(ref.current);

    const refToUnobserve = ref.current;

    return () => {
      if (refToUnobserve) observer.unobserve(refToUnobserve);
    };
  }, [callback, ref]);
};
